var React = require('react');

function ArrowRightLong (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.5 10.59L34.8266 6L30.5 1.41L31.832 -3.08915e-08L37.5 6L31.832 12L30.5 10.59Z","fill":"#31456A","key":0}),React.createElement("rect",{"x":"36","y":"7","width":"36","height":"2","transform":"rotate(-180 36 7)","fill":"#31456A","key":1})]);
}

ArrowRightLong.defaultProps = {"width":"38","height":"12","viewBox":"0 0 38 12","fill":"none"};

module.exports = ArrowRightLong;

ArrowRightLong.default = ArrowRightLong;
